import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchReorder } from "../../redux/action";
import VegIcon from "../../Assets/vegIcon.png";
import NonVegIcon from "../../Assets/nonVegIcon.png";
import { diet } from "../../Utills/enums";
import { addToCartFromReorder } from "../../redux/action";
import CartButton from "../../component/CartButton";
import SkeletonPage from "../../component/Skeleton/SkeletonPage";
import EmptyHungryPage from "../../component/EmptyHungry/EmptyHungryPage";
import "./ReOrderPage.scss";

const ReOrderPage = () => {
  const { restaurant, id, table } = useParams();
  const reorderList = useSelector((state) => state?.user.reorder || []);
  const menuList = useSelector((state) => state?.user.menu);
  const user = useSelector((state) => state?.user.user);
  const loading = useSelector((state) => state.user.loading);
  const [expandedUser, setExpandedUser] = useState(null);
  const allInfo = JSON.parse(localStorage.getItem("allInfo")) || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tableOtp = allInfo?.tableOtp;

  useEffect(() => {
    // dispatch(fetchReorder("999"));
    if (tableOtp) dispatch(fetchReorder(tableOtp));
  }, []);

  const groupOrdersByTime = (orders) => {
    const grouped = {};

    orders.forEach((order) => {
      const key = order.time;

      if (!grouped[key]) {
        grouped[key] = { time: order.time, items: [] };
      }

      order.items.forEach((item) => {
        grouped[key].items.push(item);
      });
    });

    return Object.values(grouped);
  };

  const getCategoryIdByMenuId = (menuId) => {
    for (let cat of menuList?.categories) {
      if (cat.items.some((i) => i.menuId === menuId)) {
        return cat.categoryId;
      }
    }
    return null;
  };

  console.log("reorderList", reorderList);
  console.log("menuList", menuList);
  //   const addToCart = (item) => {
  //   const categoryId = getCategoryIdByMenuId(item.menuId);
  // console.log("addtocart.......",item)
  // console.log("addtocart.......",categoryId)
  //   dispatch(
  //     addToCartFromReorder({
  //       menuId: item.menuId,
  //       price: item.price,
  //       qty: item.qty,
  //       categoryId
  //     })
  //   );

  //   navigate(`/${restaurant}/${id}/${table}/cart`);
  //    };

  const addToCart = (item) => {
    const categoryId = getCategoryIdByMenuId(item.menuId);

    console.log("REORDER ITEM CLICKED DATA:", item); // Is console ko check kijiye ki IDs aa rahe hain ya nahi

    dispatch(
      addToCartFromReorder({
        menuId: item.menuId,
        price: item.price,
        qty: item.qty || 1, // Agar qty na ho toh default 1
        categoryId: categoryId,
        // --- YEH PROPERTIES APNE PAYLOAD MEIN ADD KIJIYE ---
        sizeOptionId: item.sizeOptionId || null,
        sizeName: item.sizeName || null,
      }),
    );

    navigate(`/${restaurant}/${id}/${table}/cart`);
  };

  const hasValidTableOtp =
    tableOtp !== undefined && tableOtp !== null && tableOtp !== "";

  if (!hasValidTableOtp) {
    return <EmptyHungryPage text={"re-order"} />;
  }

  if (loading) {
    return <SkeletonPage />;
  }

  return (
    <div className="reorder-page">
      <CartButton />
      <div className="tab-header">
        <span className="active-tab">People ({reorderList.length})</span>
      </div>

      {reorderList.map((person) => {
        const isOpen = expandedUser === person.customerId;
        const groupedOrders = groupOrdersByTime(person.orders);

        return (
          <div key={person.customerId} className="customer-card">
            {/* HEADER */}
            <div
              className="customer-header"
              onClick={() => setExpandedUser(isOpen ? null : person.customerId)}
            >
              <div className="user-info">
                <div className="avatar">👤</div>
                <div>
                  <div className="user-name">{person.name}</div>
                  <div className="order-count">
                    {person.orders.length} past orders
                  </div>
                </div>
              </div>

              <div className="header-right">
                <span className="kot-badge">KOT</span>
                <span className={`toggle-icon ${isOpen ? "open" : ""}`}>▼</span>
              </div>
            </div>

            {/* EXPANDABLE SECTION */}
            <div className={`order-group-list ${isOpen ? "open" : ""}`}>
              {groupedOrders.map((group, idx) => (
                <div key={idx} className="order-card">
                  {/* ORDER HEADER */}
                  <div className="order-top">
                    <span className="order-time">{group.time}</span>
                    <button
                      className="reorder-btn"
                      disabled={loading}
                      onClick={() => group.items.forEach(addToCart)}
                    >
                      REORDER
                    </button>
                  </div>

                  {/* ITEMS */}
                  {group.items.map((item) => (
                    <div key={item.menuId} className="item-row">
                      <div className="item-left">
                        <div>
                          <div className="reorder-item-name">
                            <img
                              src={
                                diet[item.foodTypeId] === "Veg" ||
                                diet[item.foodTypeId] === "Vegan"
                                  ? VegIcon
                                  : NonVegIcon
                              }
                              alt=""
                            />{" "}
                            {item.foodName}
                          </div>
                          <div className="item-qty">Qty: {item.qty}</div>
                        </div>
                      </div>

                      <button
                        className="repeat-btn"
                        disabled={loading}
                        onClick={() => addToCart(item)}
                      >
                        Repeat
                      </button>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReOrderPage;
